import { Injectable } from '@angular/core';
import { HttpErrorResponse, HttpEvent, HttpHandler, HttpRequest, HttpParams } from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { catchError, tap } from 'rxjs/operators';
import { AppHttpParams } from '../../shared/models/app-http-params';
import { TranslateService } from '@ngx-translate/core';
import { NotificationsService } from '../services/notifications.service';
import { FormErrorMessage } from '../../shared/components/form-error-list/form-error-list.component';

@Injectable({
  providedIn: 'root'
})
export class ErrorInterceptorService {

  constructor(private translateService: TranslateService,
    private notificationsService: NotificationsService) {
  }

  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    return next.handle(req).pipe(
      tap(() => [], () => [], () => this.handleSuccess(req)),
      catchError((error) => this.handleError(req, next, error))
    );
  }

  private handleError(req: HttpRequest<any>, next: HttpHandler, error: HttpErrorResponse): Observable<any> {
    const responseLabel = req.params.get('responseLabel');

    let translationKeyPrefix = 'api.response.' + responseLabel + '.';
    const fullMessagePath = translationKeyPrefix + error.status;
    const translatedMessage = this.translateService.instant(fullMessagePath, { defaultValue: null });

    if (translatedMessage !== null) {
      const message = new FormErrorMessage();
      message.message = translatedMessage;
      const errorMessages = error.error;
      
      if (errorMessages && errorMessages.errors && errorMessages.errors.length && errorMessages.errors[0].defaultMessage) {
        message.additionalInfo = errorMessages.errors[0].defaultMessage;
      } else if (errorMessages && errorMessages.Error_Description) {
        message.additionalInfo = errorMessages.Error_Description;
      }

      return throwError(message);
    }

    if (error.status !== 401 && error.status !== 502) {
      const message = new FormErrorMessage();
      const options = req.params;

      const fullMessagePath = 'api.response.' + options.get('responseLabel') + '.' + error.status;
      message.message = this.translateService.instant(fullMessagePath);

      if (message.message === fullMessagePath) {
        message.message = this.translateService.instant('api.response.genericError');
      }


      const errorMessages = error.error;
      if (errorMessages && errorMessages.errors && errorMessages.errors.length && errorMessages.errors[0].defaultMessage) {
        message.additionalInfo = errorMessages.errors[0].defaultMessage;
      } else if (errorMessages && errorMessages.Error_Description) {
        message.additionalInfo = errorMessages.Error_Description;
      }

      return throwError(message);
    }

    return throwError(error);
  }

  private handleSuccess(req: HttpRequest<any>) {
    if (req.params.get('notifySuccess') === 'true') {
      let messageKey: string = '';

      if (req.method === 'POST') {
        messageKey = 'api.response.' + req.params.get('responseLabel') + '.201';
      } else if (req.method === 'PATCH') {
        messageKey = 'api.response.' + req.params.get('responseLabel') + '.204';
      } else if (req.method === 'PUT') {
        messageKey = 'api.response.' + req.params.get('responseLabel') + '.200';
      }

      if (messageKey) {
        let message = this.translateService.instant(messageKey);
        if (message === messageKey) {
          message = this.translateService.instant('api.response.genericSuccess');
        }
      }
    }
  }
}
